export default __webpack_public_path__ + "static/media/TITULOS_07.80371baf.png";